// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"72712c59","57":"93456dbd","156":"63ebf8fd","283":"82c8ed1a","429":"f5c0a587","619":"93b68ad2","804":"f608d7ac","884":"03bc87e2","939":"e30e6fd5","949":"9e9d3bb8"}[chunkId] + ".chunk.js";
};